import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-modal', 'accept', 'Jā');
Labels.set('ui-modal', 'decline', 'Nē');
Labels.set('ui-modal', 'dismiss', 'Labi');
Labels.set('ui-modal', 'close', 'Aizvērt uznirstošo logu');
Labels.set('ui-modal', 'back', 'Atpakaļ');
Labels.set('ui-modal', 'opened', 'Ir atvērts uznirstošais logs');
